"use client";
import { j as i } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as w } from "./tv.config-BuYIgndg.mjs";
import { TabContext as B } from "./TabContext.js";
import * as s from "react";
import { u as O } from "./useControlled-B2rPEZCb.mjs";
import { u as _ } from "./useEventCallback-CjuAhyNz.mjs";
import { u as A } from "./useRenderElement-B8V3_e8R.mjs";
import { C as H } from "./CompositeList-BwSEPM9t.mjs";
import { u as z } from "./DirectionContext-D4ZBZehF.mjs";
import { T as L } from "./TabsRootContext-CBt3a0fg.mjs";
import { t as W } from "./styleHooks-CMOZRnYj.mjs";
const q = w({
  base: ["Tabs__Root"],
  variants: {
    orientation: {},
    centered: {
      true: "justify-center"
    },
    fullWidth: {
      true: "w-full"
    }
  }
}), b = /* @__PURE__ */ s.forwardRef(function(r, u) {
  const {
    className: l,
    defaultValue: g = 0,
    onValueChange: f,
    orientation: c = "horizontal",
    render: G,
    value: h,
    ...N
  } = r, p = z(), j = s.useRef([]), [a, E] = O({
    controlled: h,
    default: g,
    name: "Tabs",
    state: "value"
  }), [v, k] = s.useState(() => /* @__PURE__ */ new Map()), [t, T] = s.useState(() => /* @__PURE__ */ new Map()), [d, S] = s.useState("none"), x = _((n, o, e) => {
    E(n), S(o), f == null || f(n, e);
  }), C = s.useCallback((n, o) => {
    if (!(n === void 0 && o < 0)) {
      for (const e of v.values())
        if (n !== void 0 && e && n === (e == null ? void 0 : e.value) || n === void 0 && (e != null && e.index) && (e == null ? void 0 : e.index) === o)
          return e.id;
    }
  }, [v]), R = s.useCallback((n, o) => {
    if (!(n === void 0 && o < 0)) {
      for (const e of t.values())
        if (n !== void 0 && o > -1 && n === ((e == null ? void 0 : e.value) ?? (e == null ? void 0 : e.index) ?? void 0) || n === void 0 && o > -1 && o === ((e == null ? void 0 : e.value) ?? (e == null ? void 0 : e.index) ?? void 0))
          return e == null ? void 0 : e.id;
    }
  }, [t]), y = s.useCallback((n) => {
    if (n === void 0)
      return null;
    for (const [o, e] of t.entries())
      if (e != null && n === (e.value ?? e.index))
        return o;
    return null;
  }, [t]), D = s.useMemo(() => ({
    direction: p,
    getTabElementBySelectedValue: y,
    getTabIdByPanelValueOrIndex: R,
    getTabPanelIdByTabValueOrIndex: C,
    onValueChange: x,
    orientation: c,
    setTabMap: T,
    tabActivationDirection: d,
    value: a
  }), [p, y, R, C, x, c, T, d, a]), I = A("div", r, {
    state: {
      orientation: c,
      tabActivationDirection: d
    },
    ref: u,
    props: N,
    customStyleHookMapping: W
  });
  return /* @__PURE__ */ i.jsx(L.Provider, {
    value: D,
    children: /* @__PURE__ */ i.jsx(H, {
      elementsRef: j,
      onMapChange: k,
      children: I
    })
  });
});
process.env.NODE_ENV !== "production" && (b.displayName = "TabsRoot");
const F = (m) => {
  const { className: r, children: u, ...l } = m;
  return /* @__PURE__ */ i.jsx(B.Provider, { value: l, children: /* @__PURE__ */ i.jsx(
    b,
    {
      className: q({
        className: typeof r == "string" ? r : ""
      }),
      ...l,
      children: u
    }
  ) });
};
F.displayName = "Tabs";
export {
  F as Tabs,
  F as default
};
